class BundleItem extends HTMLElement {
  constructor() {
    super();
    this.bundleId = this.getAttribute('bundle-id');
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.placeholder = this.querySelector('.bundle-builder__selection--placeholder');
    this.productCard = null;
    this.productId = null;
    this.variantId = null;
    this.fromCart = false;
    this.lineItemKey = null;
  }

  connectedCallback() {
    document.addEventListener('bundle:update', this.onBundleUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('bundle:update', this.onBundleUpdate);
  }

  onBundleUpdate = (event) => {
    const { bundleId, action, product } = event.detail;
    if (bundleId !== this.bundleId) return;

    if (action === 'add' && product) {
      this.selectProduct(product);
    } else if (action === 'remove') {
      this.removeProduct();
    }
  };

  selectProduct(product) {
    this.productId = product.productId;
    this.variantId = product.variantId;
    this.fromCart = product.fromCart || false;
    this.lineItemKey = product.lineItemKey || null;
    if (this.checkbox) this.checkbox.checked = true;

    if (this.productCard) this.productCard.remove();

    const color = product.modelName ? product.title.replace(product.modelName, '').trim() : product.title;

    this.productCard = document.createElement('div');
    this.productCard.className = 'bundle-builder__product-card';
    this.productCard.innerHTML = `
			${product.image ? `<img src="${product.image}" alt="${product.title}" loading="lazy">` : ''}
			<div class="bundle-builder__product-card__info">
				<p class="bundle-builder__product-card__model">${product.modelName || product.title}${product.productType ? ` <span class="bundle-builder__product-card__badge">${product.productType}</span>` : ''}</p>
				<p class="bundle-builder__product-card__variant"><span class="bundle-builder__product-card__color">${color}</span><span class="spacer"></span>${product.variantTitle}</p>
			</div>
			<button class="bundle-builder__product-card__remove" type="button" aria-label="Remove ${product.title}">
				&times;
			</button>
		`;

    this.productCard.querySelector('button').addEventListener('click', this.onRemoveClick);
    this.placeholder.after(this.productCard);
    this.dispatchEvent(new Event('bundle:item-changed', { bubbles: true }));
  }

  removeProduct() {
    this.productId = null;
    this.variantId = null;
    this.fromCart = false;
    this.lineItemKey = null;
    if (this.checkbox) this.checkbox.checked = false;
    if (this.productCard) {
      this.productCard.remove();
      this.productCard = null;
    }
    this.dispatchEvent(new Event('bundle:item-changed', { bubbles: true }));
  }

  onRemoveClick = () => {
    document.dispatchEvent(
      new CustomEvent('bundle:update', {
        detail: { bundleId: this.bundleId, action: 'remove' },
      }),
    );
  };
}

customElements.define('bundle-item', BundleItem);
